"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRO_TRIAL_MAX_AI_OFFERS = exports.PRO_TRIAL_DAYS = void 0;
exports.isProTrialActive = isProTrialActive;
exports.proTrialDaysRemaining = proTrialDaysRemaining;
exports.addProTrialPeriod = addProTrialPeriod;
/** Ημέρες δοκιμαστικής περιόδου Pro για νέους λογαριασμούς (plan FREE). */
exports.PRO_TRIAL_DAYS = 30;
/** Όριο AI προσφορών κατά τη διάρκεια της δοκιμής (όχι απεριόριστο). */
exports.PRO_TRIAL_MAX_AI_OFFERS = 20;
function isProTrialActive(input, now = new Date()) {
    if (input.plan !== 'FREE')
        return false;
    if (!input.proTrialEndsAt)
        return false;
    const end = input.proTrialEndsAt instanceof Date
        ? input.proTrialEndsAt
        : new Date(input.proTrialEndsAt);
    if (Number.isNaN(end.getTime()))
        return false;
    return end.getTime() > now.getTime();
}
function proTrialDaysRemaining(input, now = new Date()) {
    if (!isProTrialActive(input, now))
        return null;
    const end = input.proTrialEndsAt instanceof Date
        ? input.proTrialEndsAt
        : new Date(input.proTrialEndsAt);
    const ms = end.getTime() - now.getTime();
    return Math.max(0, Math.ceil(ms / (24 * 60 * 60 * 1000)));
}
function addProTrialPeriod(from = new Date()) {
    const end = new Date(from);
    end.setDate(end.getDate() + exports.PRO_TRIAL_DAYS);
    return end;
}
